export interface PedidoDto {
  CC5NUM: string;
  NREGSC5: number;
  DC5EMISSAO: Date | undefined;
  CC5CLIENTE: string;
  CC5LOJACLI: string;
  CC5CLIENT: string;
  CC5LOJAENT: string;
  CA1NREDUZ: string;
  CC5LIBEROK: string;
  CC5NOTA: string;
  CC5BLQ: string;
  CC5CONDPAG: string;
  CC5TPFRETE: string;
  CC5MENNOTA: string;
  CC5MENNOT2: string;
  CC5MENNOT3: string;
  CC5MENPAD: string;
  CC5GUARITA: string;
  CC5TRANSP: string;
  CC5TIPOCLI: string;
  CC5TIPO: string;
  CC5EHCOMP: string;
  CC5CLIENTELOJA: string;
  CC5FORNECEDORLOJA: string;
  CC5VEND1: string;
  CC5ESPECI1: string;
  NC5VOLUME1: number;
  DC5DTENTR: Date | undefined;
  CGUARITADESC: string;
  CZACINTERV: string;
  CZACINTERVDESC: string;
  NQTDPENDENTE: number;
  LUTDELETA: string;
  NVALORALIBERAR: number;
  NVALORTOTAL: number;
  CATUMENPAD: string;
  CTEMP40: string;
  CTEOR1: string;
  CC5PEDEXP: string;
  status: string;
  items: Array<PedidoItemDto>;
}

export const getPedidoDefault = (): PedidoDto => {
  return {
    CC5NUM: '',
    NREGSC5: 0,
    DC5EMISSAO: undefined,
    CC5CLIENTE: '',
    CC5LOJACLI: '',
    CC5CLIENT: '',
    CC5LOJAENT: '',
    CA1NREDUZ: '',
    CC5LIBEROK: '',
    CC5NOTA: '',
    CC5BLQ: '',
    CC5CONDPAG: '',
    CC5TPFRETE: 'F',
    CC5MENNOTA: '',
    CC5MENNOT2: '',
    CC5MENNOT3: '',
    CC5MENPAD: '',
    CC5GUARITA: '',
    CC5TRANSP: '',
    CC5TIPOCLI: 'R',
    CC5TIPO: 'N',
    CC5EHCOMP: 'N',
    CC5CLIENTELOJA: '',
    CC5FORNECEDORLOJA: '',
    CC5VEND1: '',
    CC5ESPECI1: '',
    NC5VOLUME1: 0,
    DC5DTENTR: undefined,
    CGUARITADESC: '',
    CZACINTERV: '',
    CZACINTERVDESC: '',
    NQTDPENDENTE: 0,
    LUTDELETA: 'N',
    NVALORALIBERAR: 0,
    NVALORTOTAL: 0,
    CATUMENPAD: 'S',
    CTEMP40: '',
    CTEOR1: '',
    CC5PEDEXP: '',
    status: '',
    items: []
  };
};

export interface PedidoItemDto {
  CC6ITEM: string;
  CC6PRODUTO: string;
  CC6UM: string;
  CC6DESCRI: string;
  NC6QTDVEN: number;
  NC6QTDENT: number;
  NC6PRCVEN: number;
  NC6VALOR: number;
  CC6NUMPCOM: string;
  CC6ITEMPC: string;
  CC6ZCDNEGO: string;
  CC6TES: string;
  CC6OPER: string;
  NREGSC6: number;
  NC6QTDLIB: number;
  CC6SEGUM: string;
  NC6UNSVEN: number;
  NC6QTDLIB2: number;
  CC6LOCAL: string;
  NC6QTDENT2: number;
  NQTDLIBERAR: number;
  NVALLIBERAR: number;
  CZACPROJET: string;
  CB1XFAM: string;
  uuid: string;
  AUTDELETA: string;
  favorite: Array<string>;
}

export const getPedidoItemDefault = (): PedidoItemDto => {
  return {
    CC6ITEM: '',
    CC6PRODUTO: '',
    CC6UM: '',
    CC6DESCRI: '',
    NC6QTDVEN: 0,
    NC6QTDENT: 0,
    NC6PRCVEN: 0,
    NC6VALOR: 0,
    CC6NUMPCOM: '',
    CC6ITEMPC: '',
    CC6ZCDNEGO: '',
    CC6TES: '',
    CC6OPER: '',
    NREGSC6: 0,
    NC6QTDLIB: 0,
    CC6SEGUM: '',
    NC6UNSVEN: 0,
    NC6QTDLIB2: 0,
    CC6LOCAL: '',
    NC6QTDENT2: 0,
    NQTDLIBERAR: 0,
    NVALLIBERAR: 0,
    CZACPROJET: '',
    CB1XFAM: '',
    uuid: '',
    AUTDELETA:'N',
    favorite: ['edit']
  };
};

export interface PedidoDtoList {
  items: Array<PedidoDto>;
}

export const getPedidoDtoListDefault = (): PedidoDtoList => {
  return {
    items: [],
  };
};

export interface PedidoGuaritaDto {
  CC5NUM: string;
  NREGSC5: number;
  DC5EMISSAO: Date | undefined;
  CC5CLIENTE: string;
  CC5LOJACLI: string;
  CC5EHCOMP: string;
  DC5DTCORTE: Date | undefined;
  NC5REMSIMB: 0;
  CC5TIPO: string;
  CA1NREDUZ: string;
  CPLACA: string;
  CF2TRANSP: string;
  CF2ROMANEI: string;
  CZACFAZENDDESC: string;
  items: Array<PedidoGuaritaItemDto>;
}

export const getPedidoGuaritaDefault = (): PedidoGuaritaDto => {
  return {
    CC5NUM: '',
    NREGSC5: 0,
    DC5EMISSAO: undefined,
    CC5CLIENTE: '',
    CC5LOJACLI: '',
    DC5DTCORTE: undefined,
    NC5REMSIMB: 0,
    CC5TIPO: '',
    CA1NREDUZ: '',
    CPLACA: '',
    CF2TRANSP: '',
    CF2ROMANEI: '',
    CC5EHCOMP: '',
    CZACFAZENDDESC: '',
    items: []
  };
};

export interface PedidoGuaritaItemDto {
  CC6ITEM: string;
  CC6PRODUTO: string;
  CC6UM: string;
  CB1DESC: string;
  CZACPROJET: string;
  NC6QTDVEN: number;
  NC6QTDENT: number;
  NC6PRCVEN: number;
  NC6VALOR: number;
  NREGSC6: number;
  NQTDENT: number;
  NVALORFAT: number;
  NQTDMAXENT: number;
  NQTDPENENT: number;
}

export interface PedidoGuaritaDtoList {
  items: Array<PedidoGuaritaDto>;
}

export const getPedidoGuaritaDtoListDefault = (): PedidoGuaritaDtoList => {
  return {
    items: [],
  };
};

export interface NotaDto {
  CC5NUM: string;
  NREGSC5: number;
  DF2EMISSAO: Date | undefined;
  CC5CLIENTE: string;
  CC5LOJACLI: string;
  CA1NREDUZ: string;
  CF2DOC: string;
  CF2SERIE: string;
  CF2FIMP: string;
  CF2CHVNFE: string;
  CF2HORA: string;
  NREGSF2: number;
  CF2DELET: string;
  CSTATUS: string;
  CF3CODRSEF: string;
}

export const getNotaDtoDefault = (): NotaDto => {
  return {
    CC5NUM: '',
    NREGSC5: 0,
    DF2EMISSAO: undefined,
    CC5CLIENTE: '',
    CC5LOJACLI: '',
    CA1NREDUZ: '',
    CF2DOC: '',
    CF2SERIE: '',
    CF2FIMP: '',
    CF2CHVNFE: '',
    CF2HORA: '',
    NREGSF2: 0,
    CF2DELET: '',
    CSTATUS: '',
    CF3CODRSEF: '',
  };
};

export interface NotaDtoList {
  items: Array<NotaDto>;
}

export interface StatusFaturamento {
  NREGSC9: number;
  CC9NFISCAL: string;
  CC9SERIENF: string;
  CF3CODRET: string;
  CF3CHVNFE: string;
  CF3CODRSEF: string;
  CF2DOC: string;
  CF2SERIE: string;
}

export const getStatusFaturamentoDefault = (): StatusFaturamento => {
  return {
    NREGSC9: 0,
    CC9NFISCAL: '',
    CC9SERIENF: '',
    CF3CODRET: '',
    CF3CHVNFE: '',
    CF3CODRSEF: '',
    CF2DOC: '',
    CF2SERIE: '',
  };
};

export interface FiltroPedidoCliente {
  CC5NUM: string;
  CC5PEDMI: string;
  CC5PEDEXP: string;
}

export const getFiltroPedidoClienteDefault = (): FiltroPedidoCliente => {
  return {
    CC5NUM: '',
    CC5PEDMI: '',
    CC5PEDEXP: '',
  };
};

export enum TipoPedido {
  N = "Normal",
  C = "Compl.Preco/Quantidade",
  I = "Compl.ICMS",
  P = "Compl.IPI",
  D = "Dev.Compras",
  B = "Utiliza Fornecedor ",
}

export enum TipoFrete {
  F = "FOB",
  C = "CIF",
}

export enum TipoCliente {
  F = 'Cons.Final',
  L = 'Prod.Rural',
  R = 'Revendedor',
  S = 'Solidario',
  X = 'Exportacao/Importacao'
}

export interface ProgPedidoDto {
  CC5NUM: string;
  CC5CLIENTE: string;
  CC5LOJACLI: string;
  CA1NREDUZ: string;
  DC5EMISSAO: Date | undefined;
  CC5NOTA: string;
  DC5FECENT: Date | undefined;
  NC5XDSEMAN: number;
}

export const getProgPedidoDtoDefault = (): ProgPedidoDto => {
  return {
    CC5NUM: '',
    CC5CLIENTE: '',
    CC5LOJACLI: '',
    CA1NREDUZ: '',
    DC5EMISSAO: undefined,
    CC5NOTA: '',
    DC5FECENT: undefined,
    NC5XDSEMAN: 0,
  };
};

export interface ProgPedidoDtoList {
  items: Array<ProgPedidoDto>;
}

export interface FiltroProgPedido {
  CC5NUM: string;
  DC5FECENT_DE: Date | undefined;
  DC5FECENT_ATE: Date | undefined;
  DC5EMISSAO_DE: Date | undefined;
  DC5EMISSAO_ATE: Date | undefined;
  NC5XDSEMAN: number;
}

export interface ControleLogisticoDto {
  CZ00STATUS: string;
  CZ02CTNR: string;
  CEECBKAGEN: string;
  CEECBOOK: string;
  CA1NREDUZ: string;
  CZ00COD: string;
  CZ00PROCES: string;
  CEE7PEDIDO: string;
  CZ00COTNER: string;
  NZ00TARA: number;
  CZ00SELOD: string;
  CZ00NOTA: string;
  CA4NOME: string;
  DZ00DTACAR: Date | undefined;
  CZ00TERMIN: string;
  DZ00DTETER: Date | undefined;
  DZ00DTEPOR: Date | undefined;
}

export interface ControleLogisticoDtoList {
  items: Array<ControleLogisticoDto>;
}

export interface FiltroControleLogistico {
  DC5FECENT_DE: Date | undefined;
  DC5FECENT_ATE: Date | undefined;
  DC5EMISSAO_DE: Date | undefined;
  DC5EMISSAO_ATE: Date | undefined;
  NC5XDSEMAN: number;
}

export const getFiltroControleLogisticoDefault = (): FiltroControleLogistico => {
  return {
    DC5FECENT_DE: undefined,
    DC5FECENT_ATE: undefined,
    DC5EMISSAO_DE: undefined,
    DC5EMISSAO_ATE: undefined,
    NC5XDSEMAN: 0,
  };
};